import api, { unwrap } from './api';
import type { IndonesiaAddress } from '../types';

export const addressesService = {
  search: (q: string) =>
    api.get('indonesia-addresses/search', { params: { search: q } }).then(unwrap<IndonesiaAddress[]>),
};
